import React, { useState, useRef } from "react";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

const ItemType = "LETTER";

function DraggableLetter({ id, index, moveLetter }) {
  const ref = useRef(null);

  const [, drop] = useDrop({
    accept: ItemType,
    drop(item) {
      if (item.index === index) return;
      moveLetter(item.index, index);
      item.index = index;
    }
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemType,
    item: { id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  });

  drag(drop(ref));

  const style = {
    opacity: isDragging ? 0.5 : 1,
    cursor: "grab",
    margin: "0.5rem",
    padding: "0 0.2em",
    backgroundColor: "#f0f0f0",
    border: "1px solid #ccc",
    fontSize: "1.5em",
    userSelect: "none"
  };

  return (
    <div ref={ref} style={style}>
      {id}
    </div>
  );
}

function SortableLetters({ letters, onUpdate }) {
  let items = letters.map((l, i) => ({ id: `${l}-${i}`, value: l }));
  const moveLetter = (fromIndex, toIndex) => {
    const updated = [...items];
    const [moved] = updated.splice(fromIndex, 1);
    updated.splice(toIndex, 0, moved);
    onUpdate(updated.map(x => x.value));
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
        {items.map((item, index) => (
          <DraggableLetter
            key={item.id}
            id={item.value}
            index={index}
            moveLetter={moveLetter}
          />
        ))}
      </div>
    </DndProvider>
  );
}

export default SortableLetters;

